import { API_URL } from './../../constants/config';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
export interface UserCountyInterface {
  enterpriseCountyAvailable: boolean;
  enterpriseStateAvailable: boolean;
  enterpriseNationwideAvailable: boolean;
  listUserCounty: any;
  listPackages: any;
}
@Injectable()
export class CountyService {

  constructor(private http: HttpClient) { }
  listCounty: any;
  dataCountyReady = new BehaviorSubject<boolean>(false);
  userCounty = new BehaviorSubject<UserCountyInterface>(null);
  getCounty() {
    this.http.get(`${API_URL}marketing/map-county`).subscribe(res => {
      this.listCounty = res;
      this.dataCountyReady.next(true);
    }, err => {
      console.log(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/county/county.service.ts